import BaseApi from "./base"

interface CommentsApiNamespace {
  projectId: string
  taskId: string
}

interface CreateCommentParams extends CommentsApiNamespace {
  content: string
}

interface UpdateCommentParams extends CreateCommentParams {
  commentId: string
}

interface DeleteCommentParams extends CommentsApiNamespace {
  commentId: string
}

class CommentsApi extends BaseApi {
  async createComment(params: CreateCommentParams ) {
    const {
      projectId,
      taskId,
      content
    } = params

    const body = { content: content }

    return this.post(
      `/projects/${projectId}/tasks/${taskId}/comments`,
      body
    )
  }

  async updateComment(params: UpdateCommentParams) {
    const {
      projectId,
      taskId,
      content,
      commentId,
    } = params

    const body = { content: content }

    return this.patch(
      `/projects/${projectId}/tasks/${taskId}/comments/${commentId}`,
      body
    )
  }

  async deleteComment(params: DeleteCommentParams) {
    const {
      projectId,
      taskId,
      commentId,
    } = params

    return this.delete(
      `/projects/${projectId}/tasks/${taskId}/comments/${commentId}`
    )
  }
}

export default CommentsApi
